import {apiBasePath} from "../constants/constants";
import ApiService from "../utils/api-service";

export const getConstants = () => {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/constants`,
    data: {}
  })
};